import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';

// wrap external library
export default () => {
  const intl = useIntl();
  const localize = React.useCallback((key) => intl.formatMessage({ id: key }), [useIntl]);
  return localize;
};
